<template>
  <el-dialog
    title="Withdraw"
    :visible.sync="isShowWithdrawForm"
    class="medium wallet-dialog"
    :close-on-click-modal="false" @open="onOpen"
    >
    <div class="popup-inner withdraw-form" :class="{ 'loading': isProcessing }">
      <el-tag
        type="warning"
        effect="light">
        <i class="el-icon-warning"></i>Notice: Your withdrawal will be processing around 24 hours.
      </el-tag>
      <h3 class="display-flex-center text-bold"></h3>
      <div class="item">
        <label>Currency</label>
        <el-input v-model="form.currencyCode" disabled></el-input>
      </div>
      <div class="item" v-if="form.currencyCode === 'USDT'">
        <label>Network</label>
        <el-select v-model="form.network" placeholder="Please choose network">
          <el-option
            v-for="item in networks"
            :key="item.value"
            :label="item.name"
            :value="item.value">
            <span>{{ item.name }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <label>Address<span v-if="form.currencyCode === 'KAS'" style="color: #c95c5c; line-height: 1.2; margin-bottom: 10px; font-size: 12px;">&nbsp;(Must start with 'kaspa' prefix).</span></label>
        <el-input v-model="form.address"></el-input>
      </div>
      <div class="item" v-if="form.currencyCode === 'IRON'">
        <label>Memo</label>
        <div class="item-tip item-min-max memo">
          <p style="color: #c95c5c; line-height: 1.2; margin-bottom: 10px; font-size: 12px;">If the deposit platform requires MEMO. Please fill it in correctly.</p>
        </div>
        <el-input v-model="form.memo"></el-input>
      </div>
      <div class="item">
        <label>Amount ({{form.currencyCode}})</label>
        <el-input value="" v-model="form.amount" :placeholder="`Minimum ${withdrawModalData.min_withdraw || 0} ${withdrawModalData.currency}`"></el-input>
        <div class="item-tip item-min-max">
          <p>Available: <span @click="setAmount(withdrawModalData.max_withdraw)">{{withdrawModalData.max_withdraw || 0}} {{withdrawModalData.currency}}</span></p>
        </div>
      </div>

      <div class="item" v-if="isOTPRequired">
        <label>2FA code</label>
        <el-input v-model="form.code"></el-input>
      </div>

      <div class="item" v-else>
        <label>Email code</label>
         <div class="input-wrap small">
            <el-input v-model="form.code"></el-input>
            <el-button @click="sendEmailCode" :disabled="!isValidSendEmail">{{ !isValidSendEmail ? secondsLeft : 'Send' }}</el-button>
          </div>
      </div>
      <div
        class="item-calculator"
        v-loading="isCalculator"
        element-loading-text="Calculating..."
        element-loading-spinner="el-icon-loading"
      >
        <div class="item">
          <label>Received Amount ({{form.currencyCode}})</label>
          <el-input value="" v-model="estimateData.receiveAmount" type="number" disabled></el-input>
        </div>
        <template v-if="withdrawModalData.fee_type === 'PERCENT'">
          <div class="item">
            <label>Fee ({{withdrawModalData.fee * 100}}% {{form.currencyCode}})</label>
            <el-input v-model="estimateData.fee" type="number" disabled></el-input>
          </div>
        </template>
        <template v-else>
          <div class="item">
            <label>Fee ({{withdrawModalData.fee}} {{form.currencyCode}})</label>
            <el-input v-model="estimateData.fee" type="number" disabled></el-input>
          </div>
        </template>
      </div>
      <div class="item">
        <div class="item-tip item-min-max">
          <p style="color: #c95c5c; line-height: 1.2; margin-bottom: 10px; font-size: 12px;">Please make sure the information is correct before you confirm the transaction.</p>
        </div>
        <button type="button" class="btn" :disabled="!isValidatedForm" @click="withdraw"><span>Withdraw</span></button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import UtilService from '@/utils/UtilService'
export default {
  data () {
    return {
      isProcessing: false,
      isCalculator: false,
      form: {
        address: '',
        amount: '',
        currencyCode: '',
        code: '',
        memo: '',
        network: 'BSC'
      },
      estimateData: {},
      sendEmailTimer: null,
      secondsLeft: 0,
      networks: [
        {
          name: 'Binance Smart Chain (Bep20)',
          value: 'BSC'
        },
        {
          name: 'Polygon',
          value: 'PLG'
        }
      ]
    }
  },
  computed: {
    isValidSendEmail () {
      return !this.secondsLeft
    },
    isOTPRequired () {
      return this.withdrawModalData.withdraw_verify_method === 'TOTP'
    },
    withdrawModalData () {
      return this.$store.getters.withdrawModalData
    },
    isValidatedForm () {
      return this.form.address && this.form.amount && this.form.currencyCode && this.isValidAmount && this.form.code && this.isValidAddress
    },
    isValidAmount () {
      return UtilService.isLargerOrEqual(this.withdrawModalData.balance, this.form.amount)
    },
    userOverview () {
      return this.$store.getters.userOverview
    },
    isShowWithdrawForm: {
      get () {
        return this.$store.getters.isShowWithdrawForm
      },
      set () {
        this.$store.dispatch('toggleWithdrawForm')
      }
    },
    isValidAddress () {
      return this.validateAddress(this.form.currencyCode, this.form.address)
    }
  },
  watch: {
    'form.amount': _.debounce(function () {
      this.withdrawReceiptAmount()
    }, 300)
  },
  methods: {
    validateAddress (currencyCode, address) {
      if (currencyCode !== 'KAS') return true
      if (address.indexOf('kaspa:') !== 0) return false
      if (address.length !== 67) return false
      return true
    },
    sendEmailCode () {
      if (this.secondsLeft) return
      this.$store.dispatch('sendEmailCode').then(rs => {
        console.log(rs)
        if (rs.status || !rs.status) {
          this.secondsLeft = 60
          this.sendEmailTimer = setInterval(() => {
            this.secondsLeft = this.secondsLeft - 1
            if (!this.secondsLeft) {
              clearInterval(this.sendEmailTimer)
              this.secondsLeft = 0
            }
          }, 1000)
        }
      })
    },
    onOpen () {
      this.form.currencyCode = this.withdrawModalData.currency
      this.form.address = ''
      this.form.amount = ''
      this.form.code = ''
      this.form.memo = ''
      this.estimateData.receiveAmount = ''
      this.estimateData.fee = ''
    },
    withdrawReceiptAmount () {
      if (!this.isValidAmount || !this.form.amount) {
        this.estimateData = {}
        return
      }
      this.isCalculator = true
      this.$store.dispatch('withdrawReceiveAmount', this.form).then(rs => {
        this.isCalculator = false
        this.estimateData = rs.data
      }).catch(e => {
      })
    },
    withdraw () {
      if (!this.isValidatedForm) return
      this.isProcessing = true
      this.$store.dispatch('withdraw', this.form).then(rs => {
        this.isProcessing = false
        if (rs) this.$store.dispatch('toggleWithdrawForm')
      }).catch(e => {
        this.isProcessing = false
      })
    },
    setAmount (amount) {
      this.form.amount = amount || 0
      this.withdrawReceiptAmount()
    }
  }
}
</script>
